<template>
  <div class="barra-lateral-esquerdo">

    <figure @click="deslogar" class="figure-image">
      <div v-if="getDeslog" class="backGroundOrangeRed">
        <img src="/imgs/icons/power-white.svg" class="img" />
        <figcaption>Deslogado</figcaption>
      </div>
      <div v-else class="backgroundGreen">
        <img src="/imgs/icons/power-white.svg" class="img" />
        <figcaption>Logado</figcaption>
      </div>
    </figure>

    <figure @click="contacts()" class="figure-image">
      <div :class="{ 'bg-adv': getContacts }">
        <img src="/imgs/icons/address-book.svg" class="img" />
        <figcaption>Contatos</figcaption>
      </div>
    </figure>

    <figure v-if="telefone" class="figure-image">
      <div v-if="getChannel() != ''" @click="hangup" class="backGroundOrangeRed">
        <img src="/imgs/icons/telephone-forward-white.svg" class="img" alt="" />
        <figcaption>Desligar</figcaption>
      </div>
      <div v-else @click="discar">
        <img src="/imgs/icons/telephone-forward-white.svg" class="img" alt="" />
        <figcaption>Discar</figcaption>
      </div>
    </figure>

    <figure v-if="telefone" @click="pause" class="figure-image">
      <div v-if="getPause" class="backGroundOrange">
        <img src="/imgs/icons/pause-white.svg" class="img" />
        <figcaption>
          {{ time_pause_format }} <br />
          Pausado
        </figcaption>
      </div>
      <div v-else>
        <img src="/imgs/icons/pause-white.svg" class="img" />
        <figcaption>Pausar</figcaption>
      </div>
    </figure>

    <figure v-if="telefone" @click="mute" class="figure-image">
      <div v-if="getMute" class="backGroundOrange">
        <img src="/imgs/icons/mute-white.svg" class="img" alt="" />
        <figcaption>Mudo</figcaption>
      </div>
      <div v-else>
        <img src="/imgs/icons/mute-white.svg" class="img" alt="" />
        <figcaption>Mute</figcaption>
      </div>
    </figure>

    <figure @click="agendamento" class="figure-image" style="display: none">
      <div class="">
        <img src="/imgs/icons/calendar-date-white.svg" class="img" />
        <figcaption>Agendamento</figcaption>
      </div>
    </figure>

    <div hidden>{{ loadUserData }}</div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import clientData from "../../store/modules/transduson";
import 'moment-business-days';
const parsedTelefone = process.env.MIX_TELEFONE === "true";
const connection = parsedTelefone
  ? io.connect(`${location.protocol}//${location.hostname}:3001/`)
  : { on: function () { }, emit: function () { } };

export default {
  data() {
    return {
      interval_pause: "",
      time_pause: "",
      time_pause_format: "00:00:00",
      debugDisc: false,
      total_in_queue: "",
      userQueues: [],
      statusList: [],
      queuePause: false,
      selectedOption: "",
      contactDono: "",
      observacao: "",
      telefone: parsedTelefone,
      listOptTab: [],
      listReasonsTab: [],
      ramal: user.getExtension(),
      users: [],
      hangupObj: {
        dados: [],
        uniqueid: "",
        callerIdNum: "",
      },
    };
  },
  computed: {
    ...mapGetters([
      "getDeslog",
      "getModalPause",
      "getMessages",
      "getOccurrences",
      "getShowHistory",
      "getCnpj",
      "getPause",
      "getMute",
      "getQueues",
      "getExtension",
      "getId",
      "getChannel",
      "getChamada",
      "allClients",
      "getShowSpearhead",
      "getProtocol",
      "getCallTime",
      "getPauseTime",
      "oneClient",
      "getShowBarRight",
      "getTotalMyQueue",
      "getTotalInQueue",
      "getContacts",
      "getCalendar",
      "getShowBillingCampaign",
      "getStartCountdown",
      "getShowPreditivaCampaign",
      "getShowImplantacaoCampaign",
      "getMotivoPause",
    ]),
    loadUserData: function () {
      this.setExtension(user.getId());
      this.setQueues(user.getQueue());
      this.setId(user.getId());
    },
  },
  watch: {
    getPauseTime: function () {
      this.validateTimePause();
    },
    time_pause: function () {
      this.time_pause_format = moment
        .utc(this.time_pause * 1000)
        .format("HH:mm:ss");
    },
    getDeslog(value) {
      if (!value) {
        if (!this.getMessages) {
          this.setMessage();
        }
      } else {
        if (this.getMessages) {
          this.setMessage();
        }
      }
    },
  },
  created() {
    axios.get('listUsersAll').then(({ data }) => {
      this.users = data;
    });
    this.setMessage();
    if (user.getQueue().length) {
      user.getQueue().map(el => this.userQueues.push({ queue: el, logged: false, paused: false }))
    }
    if (this.telefone) return;

    this.startOrOut();
  },
  methods: {
    ...mapActions([
      "selectPause",
      "sendPauseApi",
      "sendOperatorPauseApi",
      "setOccurrences",
      "setShowHistory",
      "setModalPause",
      "setModalSchedule",
      "settModalCall",
      "setMessage",
      "fetchOcurrences",
      "fetchPauses",
      "comeBack",
      "setDeslog",
      "startOrOut",
      "setMute",
      "setExtension",
      "setQueues",
      "setId",
      "getRealTime",
      "getHasTab",
      "sendUnpause",
      "sendOperatorUnpause",
      "setChannel",
      "fetchClients",
      "fetchProtocol",
      "setShowSpearhead",
      "chooseClient",
      "chooseClientCnpj",
      "clearAllClients",
      "setCallTime",
      "setPauseTime",
      "saveProduct",
      "clearClient",
      "saveClient",
      "setShowBarRight",
      "checkTotalQUeues",
      "totalMyQueue",
      "setContacts",
      "chooseClientPhone",
      "setShowBillingCampaign",
      "setShowPreditivaCampaign",
      "setShowImplantacaoCampaign",
      "setStartCampaign",
      "setDelDataConnectLine",
      "setCallData",
    ]),
    ...mapMutations(["setClient", "setMotivoPause"]),

    getStatusList() {
      axios.get("/listOptions").then(({ data }) => {
        // this.statusList = data;
        const obj = {};
        if (data.length > 0) {
          data.forEach((el) => {
            obj[el.id] = el.name;
          });
        }
        this.statusList = obj;
      });
    },
    saveTabulacao() {
      const obj = {
        extension_line: this.hangupObj.dados[0],
        client_num: this.hangupObj.dados[1],
        status_id: this.selectedOption,
        uniqueid: this.hangupObj.uniqueid,
        call_time: (this.hangupObj && this.hangupObj.dados[2]) ? this.hangupObj.dados[2] : 0,
      };
      const request = axios
        .post("/createOption", obj)
        .then(({ data }) => {
          if (data) {
            return true;
          } else {
            return false;
          }
        });
      return request;
    },

    deletePopup() {
      const obj = {
        extension_line: this.ramal,
      };
      const request = axios.post("/deletePopup", obj)
        .then(({ data }) => {
          if (data) {
            return true;
          } else {
            return false;
          }
        });
      return request;
    },

    updateTabulacao() {
      const obj = {
        uniqueid: this.hangupObj.uniqueid,
        status_id: this.selectedOption.tabOption,
        observacao: this.selectedOption.tabObs,
        tab_reason_id: this.selectedOption.tabReasonId,
        reason: this.selectedOption.tabReasonName,
      };
      const request = axios
        .put("/updateTabulacao", obj)
        .then(({ data }) => {
          if (data) {
            return true;
          } else {
            return false;
          }
        });
      return request;
    },
    validateTimePause() {
      this.time_pause = this.getPauseTime != "null" ? this.getPauseTime : 0;
      if (this.getPauseTime != "null") {
        this.interval_pause = setInterval(() => {
          this.time_pause++;
        }, 1000);
      } else {
        clearInterval(this.interval_pause);
      }
    },
    historicol() {
      if (!this.getDeslog && !this.getShowHistory) {
        this.setShowHistory();
        this.fetchOcurrences(this.getCnpj);
      }
    },
    messages() {
      if (!this.getDeslog && !this.getMessages) this.setMessage();
    },
    discar() {
      this.settModalCall();
    },
    getTime() {
      var d = new Date();
      return d.toTimeString().replace(/.*(\d{2}:\d{2}:\d{2}).*/, "$1");
    },
    pause() {
      if (this.getPause == true) {
        this.userQueues.forEach(el => {
          if (el.paused) {
            connection.emit('QueueUnPause', {
              extension: user.getExtension(),
              queue: el.queue
            });
          }
        });

        if (this.getShowBillingCampaign) {
          this.setShowBillingCampaign();
          sessionStorage.removeItem("campaignClientBilling");
        }
        if (this.getShowPreditivaCampaign) {
          this.setShowPreditivaCampaign();
        }
        if (this.getShowImplantacaoCampaign) {
          this.setShowImplantacaoCampaign();
          sessionStorage.removeItem("campaignClientImplantacao");
        }
      } else {
        if (this.getDeslog == false) {
          this.setModalPause();
          this.fetchPauses();
        }
      }
    },
    agendamento() {
      this.setModalSchedule();
    },
    deslogar() {
      if (!this.telefone) return;
      var data = {
        queues: user.getQueue(),
        extension: user.getExtension(),
      };

      if (this.getDeslog) {
        connection.emit("QueueAdd", data, (response) => {
          response.forEach(result => {
            if (result.status === 'success') {
              let find = this.userQueues.find(el => el.queue === result.queue)
              if (find) {
                find.logged = true
              }
            } else if (result.status === 'error') {
              console.error(`Erro: ${result.message}`);
              console.error(`Detalhes: ${result.error}`);
            }
          });
        });
      } else {
        if (!this.getMessages) this.setMessage();
        if (this.getContacts) this.setContacts();
        if (this.getShowHistory) this.setShowHistory();

        connection.emit("QueueRemove", data, (response) => {
          response.forEach(result => {
            if (result.status === 'success') {
              let find = this.userQueues.find(el => el.queue === result.queue)
              if (find) {
                find.logged = false
              }
            } else if (result.status === 'error') {
              console.error(`Erro: ${result.message}`);
              console.error(`Detalhes: ${result.error}`);
            }
          });
        });
      }
    },
    mute() {
      //HABILITANDO O MUTE APENAS SE ESTIVER EM LIGAÇÃO
      if (this.getChannel()) {
        this.setMute();

        //COLOCANDO NO LOCALSTORAGE PARA PEGAR INFORMAÇÃO DO MUTE QUANDO ATUALIZAR A PÁGINA
        this.getMute == true
          ? localStorage.setItem("mute", "true")
          : localStorage.removeItem("mute");

        //CONTROLANDO SE É PARA COLOCAR O MUTE OU PARA TIRAR E ENVIANDO EMIT NECESSÁRIO
        var stateMute = this.getMute == true ? "on" : "off";
        connection.emit("MuteAudio", {
          channel: this.getChannel(),
          extension: user.getExtension(),
          state: stateMute,
        });
      }
    },
    async hangup() {
      connection.emit("hangup", {
        channel: this.getChannel(),
      });
      //Limpa o canal
      await this.setChannel("");

      //Limpa o ponta de lanca
      await clientData.mutations.delDataTransduson();
    },
    submitLogin(sub) {
      axios.post("/dialer/logs", { type: sub })
    },
    contacts() {
      this.setContacts();
    },
    async modalTab(data) {
      if (!data) return;
      if (["disca-management-tab", "preditivo_campaigns"].includes(data.Context) && data.ConnectedLineName !== "<unknown>") {

        console.log("MODALL:::", data);
        let modalTimer;

        const dataSplit = data.ConnectedLineName.split("||");
        const clientNum = dataSplit[1];
        const timeCall = moment.utc(dataSplit[2] * 1000).format("HH:mm:ss");
        this.hangupObj["dados"] = dataSplit;

        // Recupera cliente salvo no início da chamada (ScheduledPopup)
        const clientSession = sessionStorage.getItem("campaignClient");
        let client = null;
        if (clientSession) {
          client = JSON.parse(clientSession);
        }

        await this.getTabOptions();
        await this.getTabReasons();

        // 🔹 Identifica contexto
        const isScheduledClient = data.Context === "disca-management-tab" && !!client;
        const isPredictiveClient = data.Context === "preditivo_campaigns";

        // 🔹 Filtro de opções de tabulação
        let filteredTabOptions = { ...this.listOptTab };
        if (!isScheduledClient && !isPredictiveClient) {
          // só remove para cliente normal
          delete filteredTabOptions[3];
          delete filteredTabOptions[4];
        }

        let { value: option, dismiss } = await Swal.fire({
          type: "question",
          title: "<h3 style='font-size: 20px; font-weight: bold;'>Como foi esta chamada?</h3>",
          allowOutsideClick: false,
          allowEscapeKey: false,
          timer: 60000,
          html: `
        <div style="text-align: center; font-size: 16px;">
          <div style="display: flex; justify-content: center; align-items: center; margin-bottom: 10px;">
            <b>Tempo para preencher:</b> 
            <span id="c-timer-modal" style="margin-left: 5px; font-size: 16px;"></span> 
            <i class="fas fa-stopwatch" style="margin-left: 5px; font-size: 18px;"></i>
          </div>
          <hr style="border-top: 1px solid #ddd;">
          <div><b>Número do Cliente:</b> <span style="font-size: 16px;">${clientNum}</span></div>
          <div><b>Tempo de ligação:</b> <span style="font-size: 16px;">${timeCall}</span></div>
          <hr style="border-top: 1px solid #ddd;">

          <label for="tabOption" style="display: block; text-align: left; margin-top: 10px;"><b>Selecione uma opção</b></label>
          <select class="swal2-input" id="tabOption" style="width: 100%; font-size: 16px; padding: 10px; margin-bottom: 10px;" required>
            <option disabled selected value="">Selecione uma opção</option>
            ${Object.keys(filteredTabOptions).map(id => `<option value="${id}">${filteredTabOptions[id]}</option>`).join("")}
          </select>

          <div id="reasonsContainer" style="display:none;">
            <label for="tabReason" style="display: block; text-align: left; margin-top: 10px;"><b>Selecione a razão</b></label>
            <select id="tabReason" class="swal2-input" style="width: 100%; font-size: 16px; padding: 10px; margin-bottom: 10px;">
              <option disabled selected value="">Selecione uma razão</option>
            </select>
          </div>

          <label for="tabObs" style="display: block; text-align: left; margin-top: 10px;"><b>Observação para a tabulação</b></label>
          <textarea id="tabObs" aria-label="Observação para a tabulação" 
            class="swal2-textarea" placeholder="Escreva sua observação..." 
            style="width: 100%; height: 100px; font-size: 16px; padding: 10px;"></textarea>
        </div>
      `,
          customClass: {
            popup: 'custom-swal-popup',
            title: 'custom-swal-title',
            content: 'custom-swal-content'
          },
          onOpen: () => {
            modalTimer = setInterval(() => {
              const left = Swal.getTimerLeft();
              const crTimer = left != null ? moment.utc(left).format("HH:mm:ss") : "00:00:00";
              $("#c-timer-modal").html(crTimer);
            }, 100);

            const tabEl = $('#tabOption');
            const reasonEl = $('#tabReason');

            tabEl.select2({ width: '100%', placeholder: "Selecione uma opção" });
            reasonEl.select2({ width: '100%', placeholder: "Selecione uma razão" });

            tabEl.on('change', (e) => {
              const tabId = e.target.value;
              reasonEl.empty().append('<option value="" disabled selected>Selecione uma razão</option>');

              const filtered = this.listReasonsTab.filter(r => {
                if (Number(r.tab_id) !== Number(tabId)) return false;
                if (!isScheduledClient && !isPredictiveClient && Number(tabId) === 4 && Number(r.id) === 11) {
                  return false;
                }
                return true;
              });

              if (filtered.length) {
                filtered.forEach(r => reasonEl.append(new Option(r.name, r.id)));
                $('#reasonsContainer').show();
                reasonEl.trigger("change");
              } else {
                $('#reasonsContainer').hide();
              }
            });
          },
          preConfirm: () => {
            const tabOption = document.getElementById('tabOption').value;
            const tabObs = document.getElementById('tabObs').value;

            if (!tabOption) {
              Swal.showValidationMessage('Selecione uma opção de tabulação.');
              return false;
            }

            let tabReasonId = null;
            let tabReasonName = null;

            if (document.getElementById('reasonsContainer').style.display !== 'none') {
              const reasonEl = document.getElementById('tabReason');
              tabReasonId = reasonEl.value || null;
              if (!tabReasonId) {
                Swal.showValidationMessage('Selecione uma razão.');
                return false;
              }
              tabReasonName = reasonEl.options[reasonEl.selectedIndex].text;
            }

            return { tabOption, tabReasonId, tabReasonName, tabObs };
          }
        });

        clearInterval(modalTimer);

        if (dismiss) {
          option = {
            tabOption: "1",
            tabObs: "Não tabulado pelo operador",
            tabReasonId: null,
            tabReasonName: null
          };
        }

        if (option && option.tabOption) {
          this.selectedOption = option;

          const saveTabulacaoCampaign = async (callObj) => {
            if (isScheduledClient || isPredictiveClient) {
              client = {
                ...client,
                ...callObj,
                id: isPredictiveClient ? dataSplit[4] : client.id
              };

              try {
                await axios.put("updatePreditivaCampaign", client);
                if (isScheduledClient) {
                  sessionStorage.removeItem("campaignClient");
                }
              } catch (e) {
                Swal.fire({
                  position: "top-end",
                  type: "error",
                  title: "Erro ao atualizar cliente",
                  background: "#f0f0f0",
                  showConfirmButton: false,
                  timer: 1500,
                });
              }
            } else {
              // 🔹 Ligação normal -> executa todos os métodos
              if (
                this.saveTab() &&
                this.updateTab() &&
                this.saveTabulacao() &&
                this.updateTabulacao() &&
                this.deletePopup()
              );
            }

            Swal.fire({
              position: "top-end",
              type: "success",
              title: callObj.schedule_date
                ? "Tabulação e agendamento realizados com sucesso!"
                : "Tabulação realizada com sucesso!",
              background: "#f0f0f0",
              showConfirmButton: false,
              timer: 1500,
            });
          };
          // 🔹 Agendamento só para Scheduled ou Preditivo
          if ((isScheduledClient || isPredictiveClient) && [2, 3, 11, 16, 17].includes(Number(this.selectedOption.tabReasonId))) {
            const generateTimeOptions = () => {
              let times = [];
              for (let hour = 9; hour < 20; hour++) {
                times.push(`${("0" + hour).slice(-2)}:00`);
                times.push(`${("0" + hour).slice(-2)}:30`);
              }
              return times;
            };

            const timeOptionsHtml = generateTimeOptions().map(time => `<option value="${time}">${time}</option>`).join("");
            const currentDate = new Date();
            const minDateString = currentDate.toISOString().split('T')[0];
            const maxSchedulingDate = moment(currentDate).businessAdd(30).format('YYYY-MM-DD');

            const operatorOptionsHtml = this.users
              .map(u => `<option value="${u.id}">${u.name} (${u.extension_line})</option>`)
              .join("");

            const { value: schedulingData } = await Swal.fire({
              background: "#f7f9fa",
              allowOutsideClick: false,
              allowEscapeKey: false,
              html: `
            <div style="display: flex; justify-content: center; align-items: center; background-color: #3490dc; border-radius: 50%; width: 80px; height: 80px; margin: 0 auto; color: #fff;">
              <i class="fas fa-calendar-check" style="font-size: 35px;"></i>
            </div>
            <h3 style="color: #34495e; font-weight: bold; margin-top: 15px; text-align: center;">Agendar Novo Horário</h3>
            <div style="display: flex; flex-direction: column; align-items: center; font-size: 15px; margin-top: 10px; color: #2c3e50;">
              <b>Selecione a Data e Hora:</b>
              <input type="date" id="schedulingDate" value="${minDateString}" class="swal2-input" required 
                    style="width: 80%; border-radius: 8px; border: 1px solid #ccc; font-size: 15px; margin-top: 10px;"
                    min="${minDateString}"
                    max="${maxSchedulingDate}">

              <select id="schedulingTime" class="swal2-input" style="width: 80%; border-radius: 8px; border: 1px solid #ccc; font-size: 15px; margin-top: 10px;">
                ${timeOptionsHtml}
              </select>

        ${Number(this.selectedOption.tabReasonId) === 3 ? `
          <select id="schedulingOperator" class="swal2-input" 
                  style="width: 80%; border-radius: 8px !important; border: 1px solid #ccc; font-size: 15px; margin-top: 10px;">
            <option disabled selected value="">Selecione um Operador</option>
            ${operatorOptionsHtml}
          </select>
        ` : ``}
      </div>`,
              confirmButtonText: '<span style="padding: 0 15px;">Agendar</span>',
              buttonsStyling: false,
              customClass: {
                confirmButton: 'btn btn-primary'
              },
              onOpen: () => {
                const schedulingDateInput = document.getElementById('schedulingDate');
                const confirmButton = Swal.getConfirmButton();

                if (Number(this.selectedOption.tabReasonId) === 3) {
                  $("#schedulingOperator").select2({
                    width: "100%",
                    placeholder: "Selecione um Operador",
                    dropdownParent: $(".swal2-popup")
                  });

                  $(".select2-container--default .select2-selection--single").css({
                    "height": "38px",
                    "border-radius": "8px",
                    "border": "1px solid #ccc",
                    "padding": "0 10px",
                    "font-size": "15px",
                    "background-color": "#f9f9f9",
                    "display": "flex",
                    "align-items": "center",
                    "width": "80%",
                    "margin-left": "47px"
                  });

                  $(".select2-container--default .select2-selection--single .select2-selection__rendered").css({
                    "line-height": "30px",
                    "color": "#495057",
                  });

                  $(".select2-container--default .select2-selection--single .select2-selection__arrow").css({
                    "height": "100%",
                    "top": "0",
                    "width": "30%",
                  });
                }

                schedulingDateInput.addEventListener('change', (event) => {
                  const selectedDate = new Date(event.target.value);
                  const dayOfWeek = selectedDate.getUTCDay();
                  if (dayOfWeek === 0 || dayOfWeek === 6) {
                    Swal.showValidationMessage('A data selecionada cai em um fim de semana. Por favor, escolha um dia útil.');
                    confirmButton.disabled = true;
                    confirmButton.style.cursor = 'not-allowed';
                    confirmButton.style.opacity = '0.6';
                  } else {
                    Swal.resetValidationMessage();
                    confirmButton.disabled = false;
                    confirmButton.style.cursor = '';
                    confirmButton.style.opacity = '';
                  }
                });
              },
              preConfirm: () => {
                const schedulingDate = document.getElementById('schedulingDate').value;
                const schedulingTime = document.getElementById('schedulingTime').value;
                let schedulingOperator = null;

                if (!schedulingDate || !schedulingTime) {
                  Swal.showValidationMessage('Por favor, selecione uma data e hora.');
                  return false;
                }

                if (Number(this.selectedOption.tabReasonId) === 3) {
                  schedulingOperator = document.getElementById('schedulingOperator').value;
                  if (!schedulingOperator) {
                    Swal.showValidationMessage('Por favor, selecione um operador.');
                    return false;
                  }
                }

                const schedulingDatetime = `${schedulingDate}T${schedulingTime}:00`;
                return { schedulingDatetime, schedulingOperator };
              }
            });

            if (schedulingData) {
              let userName = null;
              let userRamal = null;

              if (Number(this.selectedOption.tabReasonId) === 3 && schedulingData.schedulingOperator) {
                const selectedUser = this.users.find(u => u.id == schedulingData.schedulingOperator);
                if (selectedUser) {
                  userName = selectedUser.name;
                  userRamal = selectedUser.extension_line;
                }
              }

              const callObj = {
                tab: this.selectedOption.tabOption,
                tab_reason_id: this.selectedOption.tabReasonId,
                reason: this.selectedOption.tabReasonName,
                tab_obs: this.selectedOption.tabObs || "Agendamento: " + moment(schedulingData.schedulingDatetime).format("DD/MM/YYYY HH:mm:ss"),
                call_id: this.hangupObj.uniqueid,
                call_time: timeCall,
                schedule_date: schedulingData.schedulingDatetime,
                schedule_check: "1",
                status: "ATENDIDA",
                scheduled_to: schedulingData.schedulingOperator || null,
                scheduled_name: userName || null,
                extension_scheduled: userRamal || null
              };

              await saveTabulacaoCampaign(callObj);
            }
          } else {
            const callObj = {
              tab: this.selectedOption.tabOption,
              tab_reason_id: this.selectedOption.tabReasonId,
              reason: this.selectedOption.tabReasonName,
              tab_obs: this.selectedOption.tabObs,
              call_id: this.hangupObj.uniqueid,
              call_time: timeCall,
              status: "ATENDIDA",
              schedule_date: null,
              schedule_check: '0',
              scheduled_to: null,
              scheduled_name: null,
              extension_scheduled: null
            };
            await saveTabulacaoCampaign(callObj);
          }
        }
      }
    },

    async modalTabColdLead(data) {
      if (!data) return;
      if (user.getHasTab() && data.Context === "disca-management" && data.ConnectedLineName !== "<unknown>") {
        let modalTimer;

        const dataSplit = data.ConnectedLineName.split("||");
        const clientNum = dataSplit[1];
        const timeCall = moment.utc(dataSplit[2] * 1000).format("HH:mm:ss");
        this.hangupObj["dados"] = dataSplit;

        await this.getTabOptions();
        await this.getTabReasons();

        let { value: option, dismiss } = await Swal.fire({
          type: "question",
          title: "<h3 style='font-size: 20px; font-weight: bold;'>Como foi esta chamada?</h3>",
          allowOutsideClick: false,
          allowEscapeKey: false,
          timer: 60000,
          html: `
      <div style="text-align: center; font-size: 16px;">
        <div style="display: flex; justify-content: center; align-items: center; margin-bottom: 10px;">
          <b>Tempo para preencher:</b> 
          <span id="c-timer-modal" style="margin-left: 5px; font-size: 16px;"></span> 
          <i class="fas fa-stopwatch" style="margin-left: 5px; font-size: 18px;"></i>
        </div>
        <hr style="border-top: 1px solid #ddd;">
        <div><b>Número do Cliente:</b> <span style="font-size: 16px;">${clientNum}</span></div>
        <div><b>Tempo de ligação:</b> <span style="font-size: 16px;">${timeCall}</span></div>
        <hr style="border-top: 1px solid #ddd;">

        <label for="tabOption" style="display: block; text-align: left; margin-top: 10px;"><b>Selecione uma opção</b></label>
        <select class="swal2-input" id="tabOption" style="width: 100%; font-size: 16px; padding: 10px; margin-bottom: 10px;" required>
          <option disabled selected value="">Selecione uma opção</option>
          ${Object.keys(this.listOptTab).map(id => `<option value="${id}">${this.listOptTab[id]}</option>`).join("")}
        </select>

        <div id="reasonsContainer" style="display:none;">
          <label for="tabReason" style="display: block; text-align: left; margin-top: 10px;"><b>Selecione a razão</b></label>
          <select id="tabReason" class="swal2-input" style="width: 100%; font-size: 16px; padding: 10px; margin-bottom: 10px;">
            <option disabled selected value="">Selecione uma razão</option>
          </select>
        </div>

        <label for="tabObs" style="display: block; text-align: left; margin-top: 10px;"><b>Observação para a tabulação</b></label>
        <textarea id="tabObs" aria-label="Observação para a tabulação" 
          class="swal2-textarea" placeholder="Escreva sua observação..." 
          style="width: 100%; height: 100px; font-size: 16px; padding: 10px;"></textarea>
      </div>
      `,
          customClass: {
            popup: 'custom-swal-popup',
            title: 'custom-swal-title',
            content: 'custom-swal-content'
          },
          onOpen: () => {
            modalTimer = setInterval(() => {
              const left = Swal.getTimerLeft();
              const crTimer = left != null ? moment.utc(left).format("HH:mm:ss") : "00:00:00";
              $("#c-timer-modal").html(crTimer);
            }, 100);

            const tabEl = $('#tabOption');
            const reasonEl = $('#tabReason');

            // ativa select2
            tabEl.select2({ width: '100%', placeholder: "Selecione uma opção" });
            reasonEl.select2({ width: '100%', placeholder: "Selecione uma razão" });

            // preenchimento dinâmico das razões
            tabEl.on('change', (e) => {
              const tabId = e.target.value;
              reasonEl.empty().append('<option value="" disabled selected>Selecione uma razão</option>');
              const filtered = this.listReasonsTab.filter(r => Number(r.tab_id) === Number(tabId));
              if (filtered.length) {
                filtered.forEach(r => {
                  reasonEl.append(new Option(r.name, r.id));
                });
                $('#reasonsContainer').show();
                reasonEl.trigger("change"); // força update
              } else {
                $('#reasonsContainer').hide();
              }
            });
          },
          preConfirm: () => {
            const tabOption = document.getElementById('tabOption').value;
            const tabObs = document.getElementById('tabObs').value;

            if (!tabOption) {
              Swal.showValidationMessage('Selecione uma opção de tabulação.');
              return false;
            }

            let tabReasonId = null;
            let tabReasonName = null;

            if (document.getElementById('reasonsContainer').style.display !== 'none') {
              const reasonEl = document.getElementById('tabReason');
              tabReasonId = reasonEl.value || null;
              if (!tabReasonId) {
                Swal.showValidationMessage('Selecione uma razão.');
                return false;
              }
              tabReasonName = reasonEl.options[reasonEl.selectedIndex].text;
            }

            return {
              tabOption,
              tabReasonId,
              tabReasonName,
              tabObs
            };
          }
        });

        clearInterval(modalTimer);

        if (dismiss) {
          option = {
            tabOption: "1",
            tabObs: "Não tabulado pelo operador",
            tabReasonId: null,
            tabReasonName: null
          };
        }

        if (option && option.tabOption) {
          this.selectedOption = option;

          if ([2, 3, 11, 16, 17].includes(Number(this.selectedOption.tabReasonId))) {
            const generateTimeOptions = () => {
              let times = [];
              for (let hour = 9; hour < 18; hour++) {
                times.push(`${("0" + hour).slice(-2)}:00`);
                times.push(`${("0" + hour).slice(-2)}:30`);
              }
              return times;
            };

            const timeOptionsHtml = generateTimeOptions().map(time => `<option value="${time}">${time}</option>`).join("");
            const currentDate = new Date();
            const minDateString = currentDate.toISOString().split('T')[0];
            const clientSession = sessionStorage.getItem("campaignClientBilling");
            const { activation_date } = JSON.parse(clientSession);
            const activationDate = moment(activation_date);
            const maxSchedulingDate = activationDate.businessAdd(30).format('YYYY-MM-DD');

            // 🔹 monta options de operadores com nome + ramal
            const operatorOptionsHtml = this.users
              .map(u => `<option value="${u.id}">${u.name} (${u.extension_line})</option>`)
              .join("");

            const { value: schedulingData } = await Swal.fire({
              background: "#f7f9fa",
              allowOutsideClick: false,
              allowEscapeKey: false,
              html: `
      <div style="display: flex; justify-content: center; align-items: center; background-color: #3490dc; border-radius: 50%; width: 80px; height: 80px; margin: 0 auto; color: #fff; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);">
        <i class="fas fa-calendar-check" style="font-size: 35px;"></i>
      </div>
      <h3 style="color: #34495e; font-weight: bold; margin-top: 15px; text-align: center;">Agendar Novo Horário</h3>
      <div style="display: flex; flex-direction: column; align-items: center; font-size: 15px; line-height: 1.5; margin-top: 10px; color: #2c3e50;">
        <b>Selecione a Data e Hora:</b>
        <input type="date" id="schedulingDate" value="${minDateString}" class="swal2-input" required 
              style="width: 80%; border-radius: 8px !important; border: 1px solid #ccc; font-size: 15px; margin-top: 10px;"
              min="${minDateString}"
              max="${maxSchedulingDate}">
        <select id="schedulingTime" class="swal2-input" style="width: 80%; border-radius: 8px !important; border: 1px solid #ccc; font-size: 15px; margin-top: 10px;">
          ${timeOptionsHtml}
        </select>

        ${Number(this.selectedOption.tabReasonId) === 3 ? `
          <select id="schedulingOperator" class="swal2-input" 
                  style="width: 80%; border-radius: 8px !important; border: 1px solid #ccc; font-size: 15px; margin-top: 10px;">
            <option disabled selected value="">Selecione um Operador</option>
            ${operatorOptionsHtml}
          </select>
        ` : ``}
      </div>`,
              confirmButtonText: '<span style="padding: 0 15px;">Agendar</span>',
              buttonsStyling: false,
              customClass: {
                confirmButton: 'btn btn-primary'
              },
              onOpen: () => {
                const schedulingDateInput = document.getElementById('schedulingDate');
                const confirmButton = Swal.getConfirmButton();

                if (Number(this.selectedOption.tabReasonId) === 3) {
                  $("#schedulingOperator").select2({
                    width: "100%",
                    placeholder: "Selecione um Operador",
                    dropdownParent: $(".swal2-popup")
                  });

                  $(".select2-container--default .select2-selection--single").css({
                    "height": "38px",
                    "border-radius": "8px",
                    "border": "1px solid #ccc",
                    "padding": "0 10px",
                    "font-size": "15px",
                    "background-color": "#f9f9f9",
                    "display": "flex",
                    "align-items": "center",
                    "width": "80%",
                    "margin-left": "47px"
                  });

                  $(".select2-container--default .select2-selection--single .select2-selection__rendered").css({
                    "line-height": "30px",
                    "color": "#495057",
                  });

                  $(".select2-container--default .select2-selection--single .select2-selection__arrow").css({
                    "height": "100%",
                    "top": "0",
                    "width": "30%",
                  });
                }

                schedulingDateInput.addEventListener('change', (event) => {
                  const selectedDate = new Date(event.target.value);
                  const dayOfWeek = selectedDate.getUTCDay();
                  if (dayOfWeek === 0 || dayOfWeek === 6) {
                    Swal.showValidationMessage('A data selecionada cai em um fim de semana. Por favor, escolha um dia útil.');
                    confirmButton.disabled = true;
                    confirmButton.style.cursor = 'not-allowed';
                    confirmButton.style.opacity = '0.6';
                  } else {
                    Swal.resetValidationMessage();
                    confirmButton.disabled = false;
                    confirmButton.style.cursor = '';
                    confirmButton.style.opacity = '';
                  }
                });
              },
              preConfirm: () => {
                const schedulingDate = document.getElementById('schedulingDate').value;
                const schedulingTime = document.getElementById('schedulingTime').value;
                let schedulingOperator = null;

                if (!schedulingDate || !schedulingTime) {
                  Swal.showValidationMessage('Por favor, selecione uma data e hora.');
                  return false;
                }

                if (Number(this.selectedOption.tabReasonId) === 3) {
                  schedulingOperator = document.getElementById('schedulingOperator').value;
                  if (!schedulingOperator) {
                    Swal.showValidationMessage('Por favor, selecione um operador.');
                    return false;
                  }
                }

                const schedulingDatetime = `${schedulingDate}T${schedulingTime}:00`;
                return { schedulingDatetime, schedulingOperator };
              }
            });

            if (schedulingData) {
              let userName = null;
              let userRamal = null;

              if (Number(this.selectedOption.tabReasonId) === 3 && schedulingData.schedulingOperator) {
                const selectedUser = this.users.find(u => u.id == schedulingData.schedulingOperator);
                if (selectedUser) {
                  userName = selectedUser.name;
                  userRamal = selectedUser.extension_line;
                }
              }

              const callObj = {
                tab: this.selectedOption.tabOption,
                tab_reason_id: this.selectedOption.tabReasonId,
                reason: this.selectedOption.tabReasonName,
                tab_obs: this.selectedOption.tabObs,
                call_id: this.hangupObj.uniqueid,
                scheduling_datetime: schedulingData.schedulingDatetime,
                scheduled_to: schedulingData.schedulingOperator || null,
                scheduled_name: userName || null,
                extension_scheduled: userRamal || null
              };

              console.log("callObj", callObj);
              this.setCallData(callObj);
              this.setStartCampaign();
              Swal.fire({
                position: "top-end",
                type: "success",
                title: "Tabulação e agendamento realizados com sucesso!",
                background: "#f0f0f0",
                showConfirmButton: false,
                timer: 1500,
              });
            }
          } else {
            if (this.saveTab() && this.updateTab() && this.saveTabulacao() && this.updateTabulacao() && this.deletePopup()) {
              const callObj = {
                tab: this.selectedOption.tabOption,
                tab_reason_id: this.selectedOption.tabReasonId,
                reason: this.selectedOption.tabReasonName,
                tab_obs: this.selectedOption.tabObs,
                call_id: this.hangupObj.uniqueid,
                scheduling_datetime: null,
              };
              this.setCallData(callObj);
              this.setStartCampaign();
              Swal.fire({
                position: "top-end",
                type: "success",
                title: "Tabulação realizada com sucesso!",
                background: "#f0f0f0",
                showConfirmButton: false,
                timer: 1500,
              });
            } else {
              Swal.fire({
                position: "top-end",
                type: "error",
                title: "Não foi possível salvar a tabulação",
                background: "#f0f0f0",
                showConfirmButton: false,
                timer: 1500,
              });
            }
          }
        }
      }
    },

    async modalTabEsporadico(data) {
      if (!data) return;
      if (!data) return;
      if (user.getHasTab() && data.Context === "disca-management" && data.ConnectedLineName !== "<unknown>") {
        let modalTimer;

        const dataSplit = data.ConnectedLineName.split("||");
        const clientNum = dataSplit[1];
        const timeCall = moment.utc(dataSplit[2] * 1000).format("HH:mm:ss");
        this.hangupObj["dados"] = dataSplit;

        await this.getTabOptions();
        await this.getTabReasons();

        let { value: option, dismiss } = await Swal.fire({
          type: "question",
          title: "<h3 style='font-size: 20px; font-weight: bold;'>Como foi esta chamada?</h3>",
          allowOutsideClick: false,
          allowEscapeKey: false,
          timer: 60000,
          html: `
      <div style="text-align: center; font-size: 16px;">
        <div style="display: flex; justify-content: center; align-items: center; margin-bottom: 10px;">
          <b>Tempo para preencher:</b> 
          <span id="c-timer-modal" style="margin-left: 5px; font-size: 16px;"></span> 
          <i class="fas fa-stopwatch" style="margin-left: 5px; font-size: 18px;"></i>
        </div>
        <hr style="border-top: 1px solid #ddd;">
        <div><b>Número do Cliente:</b> <span style="font-size: 16px;">${clientNum}</span></div>
        <div><b>Tempo de ligação:</b> <span style="font-size: 16px;">${timeCall}</span></div>
        <hr style="border-top: 1px solid #ddd;">

        <label for="tabOption" style="display: block; text-align: left; margin-top: 10px;"><b>Selecione uma opção</b></label>
        <select class="swal2-input" id="tabOption" style="width: 100%; font-size: 16px; padding: 10px; margin-bottom: 10px;" required>
          <option disabled selected value="">Selecione uma opção</option>
          ${Object.keys(this.listOptTab).map(id => `<option value="${id}">${this.listOptTab[id]}</option>`).join("")}
        </select>

        <div id="reasonsContainer" style="display:none;">
          <label for="tabReason" style="display: block; text-align: left; margin-top: 10px;"><b>Selecione a razão</b></label>
          <select id="tabReason" class="swal2-input" style="width: 100%; font-size: 16px; padding: 10px; margin-bottom: 10px;">
            <option disabled selected value="">Selecione uma razão</option>
          </select>
        </div>

        <label for="tabObs" style="display: block; text-align: left; margin-top: 10px;"><b>Observação para a tabulação</b></label>
        <textarea id="tabObs" aria-label="Observação para a tabulação" 
          class="swal2-textarea" placeholder="Escreva sua observação..." 
          style="width: 100%; height: 100px; font-size: 16px; padding: 10px;"></textarea>
      </div>
      `,
          customClass: {
            popup: 'custom-swal-popup',
            title: 'custom-swal-title',
            content: 'custom-swal-content'
          },
          onOpen: () => {
            modalTimer = setInterval(() => {
              const left = Swal.getTimerLeft();
              const crTimer = left != null ? moment.utc(left).format("HH:mm:ss") : "00:00:00";
              $("#c-timer-modal").html(crTimer);
            }, 100);

            const tabEl = $('#tabOption');
            const reasonEl = $('#tabReason');

            // ativa select2
            tabEl.select2({ width: '100%', placeholder: "Selecione uma opção" });
            reasonEl.select2({ width: '100%', placeholder: "Selecione uma razão" });

            // preenchimento dinâmico das razões
            tabEl.on('change', (e) => {
              const tabId = e.target.value;
              reasonEl.empty().append('<option value="" disabled selected>Selecione uma razão</option>');
              const filtered = this.listReasonsTab.filter(r => Number(r.tab_id) === Number(tabId));
              if (filtered.length) {
                filtered.forEach(r => {
                  reasonEl.append(new Option(r.name, r.id));
                });
                $('#reasonsContainer').show();
                reasonEl.trigger("change"); // força update
              } else {
                $('#reasonsContainer').hide();
              }
            });
          },
          preConfirm: () => {
            const tabOption = document.getElementById('tabOption').value;
            const tabObs = document.getElementById('tabObs').value;

            if (!tabOption) {
              Swal.showValidationMessage('Selecione uma opção de tabulação.');
              return false;
            }

            let tabReasonId = null;
            let tabReasonName = null;

            if (document.getElementById('reasonsContainer').style.display !== 'none') {
              const reasonEl = document.getElementById('tabReason');
              tabReasonId = reasonEl.value || null;
              if (!tabReasonId) {
                Swal.showValidationMessage('Selecione uma razão.');
                return false;
              }
              tabReasonName = reasonEl.options[reasonEl.selectedIndex].text;
            }

            return {
              tabOption,
              tabReasonId,
              tabReasonName,
              tabObs
            };
          }
        });

        clearInterval(modalTimer);

        if (dismiss) {
          option = {
            tabOption: "1",
            tabObs: "Não tabulado pelo operador",
            tabReasonId: null,
            tabReasonName: null
          };
        }

        if (option && option.tabOption) {
          this.selectedOption = option;

          if ([2, 3, 11, 16, 17].includes(Number(this.selectedOption.tabReasonId))) {
            const generateTimeOptions = () => {
              let times = [];
              for (let hour = 9; hour < 18; hour++) {
                times.push(`${("0" + hour).slice(-2)}:00`);
                times.push(`${("0" + hour).slice(-2)}:30`);
              }
              return times;
            };

            const timeOptionsHtml = generateTimeOptions().map(time => `<option value="${time}">${time}</option>`).join("");
            const currentDate = new Date();
            const minDateString = currentDate.toISOString().split('T')[0];
            const clientSession = sessionStorage.getItem("campaignClientImplantacao");
            const { activation_date } = JSON.parse(clientSession);
            const activationDate = moment(activation_date);
            const maxSchedulingDate = activationDate.businessAdd(30).format('YYYY-MM-DD');

            // 🔹 monta options de operadores com nome + ramal
            const operatorOptionsHtml = this.users
              .map(u => `<option value="${u.id}">${u.name} (${u.extension_line})</option>`)
              .join("");

            const { value: schedulingData } = await Swal.fire({
              background: "#f7f9fa",
              allowOutsideClick: false,
              allowEscapeKey: false,
              html: `
      <div style="display: flex; justify-content: center; align-items: center; background-color: #3490dc; border-radius: 50%; width: 80px; height: 80px; margin: 0 auto; color: #fff; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);">
        <i class="fas fa-calendar-check" style="font-size: 35px;"></i>
      </div>
      <h3 style="color: #34495e; font-weight: bold; margin-top: 15px; text-align: center;">Agendar Novo Horário</h3>
      <div style="display: flex; flex-direction: column; align-items: center; font-size: 15px; line-height: 1.5; margin-top: 10px; color: #2c3e50;">
        <b>Selecione a Data e Hora:</b>
        <input type="date" id="schedulingDate" value="${minDateString}" class="swal2-input" required 
              style="width: 80%; border-radius: 8px !important; border: 1px solid #ccc; font-size: 15px; margin-top: 10px;"
              min="${minDateString}"
              max="${maxSchedulingDate}">
        <select id="schedulingTime" class="swal2-input" style="width: 80%; border-radius: 8px !important; border: 1px solid #ccc; font-size: 15px; margin-top: 10px;">
          ${timeOptionsHtml}
        </select>

        ${Number(this.selectedOption.tabReasonId) === 3 ? `
          <select id="schedulingOperator" class="swal2-input" 
                  style="width: 80%; border-radius: 8px !important; border: 1px solid #ccc; font-size: 15px; margin-top: 10px;">
            <option disabled selected value="">Selecione um Operador</option>
            ${operatorOptionsHtml}
          </select>
        ` : ``}
      </div>`,
              confirmButtonText: '<span style="padding: 0 15px;">Agendar</span>',
              buttonsStyling: false,
              customClass: {
                confirmButton: 'btn btn-primary'
              },
              onOpen: () => {
                const schedulingDateInput = document.getElementById('schedulingDate');
                const confirmButton = Swal.getConfirmButton();

                if (Number(this.selectedOption.tabReasonId) === 3) {
                  $("#schedulingOperator").select2({
                    width: "100%",
                    placeholder: "Selecione um Operador",
                    dropdownParent: $(".swal2-popup")
                  });

                  $(".select2-container--default .select2-selection--single").css({
                    "height": "38px",
                    "border-radius": "8px",
                    "border": "1px solid #ccc",
                    "padding": "0 10px",
                    "font-size": "15px",
                    "background-color": "#f9f9f9",
                    "display": "flex",
                    "align-items": "center",
                    "width": "80%",
                    "margin-left": "47px"
                  });

                  $(".select2-container--default .select2-selection--single .select2-selection__rendered").css({
                    "line-height": "30px",
                    "color": "#495057",
                  });

                  $(".select2-container--default .select2-selection--single .select2-selection__arrow").css({
                    "height": "100%",
                    "top": "0",
                    "width": "30%",
                  });
                }

                schedulingDateInput.addEventListener('change', (event) => {
                  const selectedDate = new Date(event.target.value);
                  const dayOfWeek = selectedDate.getUTCDay();
                  if (dayOfWeek === 0 || dayOfWeek === 6) {
                    Swal.showValidationMessage('A data selecionada cai em um fim de semana. Por favor, escolha um dia útil.');
                    confirmButton.disabled = true;
                    confirmButton.style.cursor = 'not-allowed';
                    confirmButton.style.opacity = '0.6';
                  } else {
                    Swal.resetValidationMessage();
                    confirmButton.disabled = false;
                    confirmButton.style.cursor = '';
                    confirmButton.style.opacity = '';
                  }
                });
              },
              preConfirm: () => {
                const schedulingDate = document.getElementById('schedulingDate').value;
                const schedulingTime = document.getElementById('schedulingTime').value;
                let schedulingOperator = null;

                if (!schedulingDate || !schedulingTime) {
                  Swal.showValidationMessage('Por favor, selecione uma data e hora.');
                  return false;
                }

                if (Number(this.selectedOption.tabReasonId) === 3) {
                  schedulingOperator = document.getElementById('schedulingOperator').value;
                  if (!schedulingOperator) {
                    Swal.showValidationMessage('Por favor, selecione um operador.');
                    return false;
                  }
                }

                const schedulingDatetime = `${schedulingDate}T${schedulingTime}:00`;
                return { schedulingDatetime, schedulingOperator };
              }
            });

            if (schedulingData) {
              let userName = null;
              let userRamal = null;

              if (Number(this.selectedOption.tabReasonId) === 3 && schedulingData.schedulingOperator) {
                const selectedUser = this.users.find(u => u.id == schedulingData.schedulingOperator);
                if (selectedUser) {
                  userName = selectedUser.name;
                  userRamal = selectedUser.extension_line;
                }
              }

              const callObj = {
                tab: this.selectedOption.tabOption,
                tab_reason_id: this.selectedOption.tabReasonId,
                reason: this.selectedOption.tabReasonName,
                tab_obs: this.selectedOption.tabObs,
                call_id: this.hangupObj.uniqueid,
                scheduling_datetime: schedulingData.schedulingDatetime,
                scheduled_to: schedulingData.schedulingOperator || null,
                scheduled_name: userName,
                extension_scheduled: userRamal
              };

              console.log("callObj", callObj);
              this.setCallData(callObj);
              this.setStartCampaign();
              Swal.fire({
                position: "top-end",
                type: "success",
                title: "Tabulação e agendamento realizados com sucesso!",
                background: "#f0f0f0",
                showConfirmButton: false,
                timer: 1500,
              });
            }
          } else {
            if (this.saveTab() && this.updateTab() && this.saveTabulacao() && this.updateTabulacao() && this.deletePopup()) {
              const callObj = {
                tab: this.selectedOption.tabOption,
                tab_reason_id: this.selectedOption.tabReasonId,
                reason: this.selectedOption.tabReasonName,
                tab_obs: this.selectedOption.tabObs,
                call_id: this.hangupObj.uniqueid,
                scheduling_datetime: null,
              };
              this.setCallData(callObj);
              this.setStartCampaign();
              Swal.fire({
                position: "top-end",
                type: "success",
                title: "Tabulação realizada com sucesso!",
                background: "#f0f0f0",
                showConfirmButton: false,
                timer: 1500,
              });
            } else {
              Swal.fire({
                position: "top-end",
                type: "error",
                title: "Não foi possível salvar a tabulação",
                background: "#f0f0f0",
                showConfirmButton: false,
                timer: 1500,
              });
            }
          }
        }
      }
    },

    async getTabOptions() {
      let tabRoute = "listTabOptionsBilling";
      return await axios.get(tabRoute).then(({ data }) => {
        this.listOptTab = data;
      });
    },

    async getTabReasons() {
      return await axios.get("/listTabReasons").then(({ data }) => {
        this.listReasonsTab = data;
      });
    },
    saveTab() {
      const obj = {
        exten: this.hangupObj.dados[0],
        phone: this.hangupObj.dados[1],
        status_id: this.selectedOption.tabOption,
        observation: this.selectedOption.tabObs || null,
        uniqueid: this.hangupObj.uniqueid,
        call_time: this.hangupObj.dados[2],
      };

      return axios.post("/saveTab", obj).then(({ data }) => !!data);
    },
    updateTab() {
      const obj = {
        uniqueid: this.hangupObj.uniqueid,
        status_id: this.selectedOption.tabOption,
        observation: this.selectedOption.tabObs || null,
      };

      return axios.put("/updateTab", obj).then(({ data }) => !!data);
    },
  },
  mounted() {
    this.checkTotalQUeues();
    this.totalMyQueue();

    this.getStatusList();

    // CAPTURANDO INFORMALÇÕES (SE ESTÁ EM LIGAÇÃO E SE ESTÁ LOGADO NA FILA)
    connection.emit("CoreShowChannels", {
      ramal: user.getExtension(),
    });

    // EVENTO PARA CAPTURAR DADOS DE LIGAÇÃO EM CURSO DO OPERADOR LOGADO
    connection.on(`CoreShowChannel-${user.getExtension()}`, async (data) => {
      //HABILITANDO CONTADOR E PASSANDO PRO CONTADOR QUANTO TEMPO ESTA EM LIGAÇÃO
      this.setCallTime(moment.duration(data.Duration).asSeconds());

      //BUSCANDO CLIENTE E PROTOCOLO DE ATENDIMENTO
      var self = this;

      this.fetchClients(data.ConnectedLineNum).then(async function () {
        //Recupera os dados tratado
        let phoneSplit = data.ConnectedLineName.split("||");
        let dataPhone = phoneSplit[1];

        if (self.allClients && self.allClients.length > 0) {
          self.chooseClient(self.allClients[0]);
          self.chooseClientCnpj(self.allClients[0]["cpf_cnpj"]);
          self.setShowSpearhead();
          // self.clearAllClients();
        } else {
          //SETANDO OS VALORES VAZIOS SE NÃO TIVER CLIENTE
          self.chooseClient({
            at_user_id: "",
            birthday: "",
            cep: "",
            city: "",
            complement: "",
            cpf: "",
            created_at: "",
            email: "",
            id: "",
            name: "",
            neighborhood: "",
            number: "",
            phone: dataPhone,
            phone_2: "",
            reference: "",
            rg: "",
            street: "",
            updated_at: "",
          });
          self.setShowSpearhead();
        }
      });
      this.fetchProtocol();
      //SETANDO O CANAL DA LIGAÇÃO ATUAL
      this.setChannel(data.Channel);

      if (data.ConnectedLineName.includes("||ramal")) {
        await clientData.mutations.setDataTransduson(
          `${data.ConnectedLineNum}||redirecionamento`
        );
      } else if (data.ConnectedLineName.includes("<unknown>")) {
        await clientData.mutations.setDataTransduson(`${data.Exten}||externo`);
      } else {
        await clientData.mutations.setDataTransduson(data.ConnectedLineName);
      }

      //HABILITANDO O MUTE NOVAMENTE CASO SEJA ATUALIZADO A PÁGINA
      localStorage.getItem("mute") && this.getChannel() && this.getMute == false
        ? this.setMute()
        : false;
    });

    // EVENT NECESSÁRIO PARA HABILITAR OS BOTÕES (LOGADO E PAUSA) QUANDO APESSOA ENTRA NA PAGINA
    connection.emit("QueueStatus", {
      ramal: user.getExtension(),
    });

    connection.on(`QueueMember-${user.getExtension()}`, async (data) => {
      const queuename = data.Queue
      let find = this.userQueues.find(el => el.queue === queuename)
      if (find) find.logged = true
      if (this.userQueues.some(el => el.logged) && this.getDeslog) this.setDeslog();

      if (data.Paused == 1) {
        //INICIANDO CONTADOR DE PAUSA CASO ESTEJA EM PAUSA
        this.setPauseTime(data.LastPause);
        const time = this.getTime();
        const dataPause = {
          pauseId: data.PausedReason,
          tempo: `${time}`,
          userId: this.getId,
          preserveButton: this.userQueues.some(el => el.paused)
        };
        this.selectPause(dataPause);
        // }
        if (find) find.paused = true

        if (dataPause.pauseId === "Campanha Preditiva") {
          if (!this.getShowPreditivaCampaign) {
            this.setShowPreditivaCampaign();
          }
        }
        if (dataPause.pauseId === "Campanha Cold Lead") {
          if (!this.getShowBillingCampaign) {
            this.setShowBillingCampaign();
          }
        }
        if (dataPause.pauseId === "Campanha Esporádico") {
          if (!this.getShowImplantacaoCampaign) {
            this.setShowImplantacaoCampaign();
          }
        }
      }
    });

    // VALIDANDO QUANDO USUÁRIO É INSERIDO NA FILA
    connection.on(`QueueMemberAdded-${user.getExtension()}`, (data) => {
      const queuename = data.Queue
      let find = this.userQueues.find(el => el.queue === queuename)
      if (find) find.logged = true

      if (this.getDeslog) {
        this.setDeslog();
        this.startOrOut();
        this.submitLogin("LOGIN");
      }
    });

    // VALIDANDO QUANDO USUÁRIO É EXPULSO DA FILA
    connection.on(`QueueMemberRemoved-${user.getExtension()}`, (data) => {
      const queuename = data.Queue
      let find = this.userQueues.find(el => el.queue === queuename)
      if (find) find.logged = false

      if (!this.userQueues.some(el => el.logged)) {
        if (this.getPause == true) {
          this.userQueues.forEach(el => {
            if (el.paused) {
              connection.emit('QueueUnPause', {
                extension: user.getExtension(),
                queue: el.queue
              });
            }
          })
        }
        if (!this.getDeslog) this.setDeslog();
        this.startOrOut();
        this.submitLogin("LOGOUT");
      }
    });

    // PEGANDO CANAL DO USUÁRIO EM LIGAÇÃO
    connection.on(`NewConnectedLine-${user.getExtension()}`, async (data) => {
      this.chooseClientPhone("");

      console.log("newConnect:::", data);

      if (data.ConnectedLineName.includes("RAMAL||")) {
        await clientData.mutations.setDataTransduson(
          `${data.ConnectedLineNum}||interna`
        );
      } else if (data.Exten != 'h') {
        await clientData.mutations.setDataTransduson(data.ConnectedLineName);
      }

      //Recupera os dados tratado
      let phoneSplit = data.ConnectedLineName.split("||");
      let dataPhone = phoneSplit[1];

      //INICIANDO O CONTADOR COM ZERO
      this.setCallTime(1);

      //BUSCANDO CLIENTE E PROTOCOLO DE ATENDIMENTO
      var self = this;
      this.fetchClients(dataPhone).then(function () {
        if (self.allClients && self.allClients.length > 0) {
          self.chooseClient(self.allClients[0]);
          self.chooseClientCnpj(self.allClients[0]["cpf_cnpj"]);
          self.setShowSpearhead();
          self.clearAllClients();
        } else {
          //SETANDO OS VALORES VAZIOS SE NÃO TIVER CLIENTE
          self.chooseClient({
            at_user_id: "",
            birthday: "",
            cep: "",
            city: "",
            complement: "",
            cpf: "",
            created_at: "",
            email: "",
            id: "",
            name: "",
            neighborhood: "",
            number: "",
            phone: dataPhone,
            phone_2: "",
            reference: "",
            rg: "",
            street: "",
            updated_at: "",
          });
          self.setShowSpearhead();
        }
      });
      this.fetchProtocol();

      //SETANDO CANAL NO STATE
      this.setChannel(data.Channel);
    });

    // DESABILITANDO BOTÃO DE MUTE QUANDO FINALIZADO A LIGAÇÃO
    connection.on(`Hangup-${user.getExtension()}`, async (data) => {

      console.log("HANGUP:::", data);

      this.setShowSpearhead();
      this.hangupObj["uniqueid"] = data.Uniqueid;


      if (localStorage.getItem("mute")) {
        this.setMute();
        localStorage.removeItem("mute");
      }

      if (this.getMotivoPause == "Campanha Cold Lead") {
        this.modalTabColdLead(data);
      } else if (this.getMotivoPause == "Campanha Esporádico") {
        this.modalTabEsporadico(data);
      } else {
        this.modalTab(data);
      }

      //CADASTRANDO A LIGAÇÃO REALIZADA DO CLIENTE
      var structClient = {
        at_user_id: this.getId,
        protocol: this.getProtocol.protocol,
        uniqueid: data.Linkedid,
        type: "telefonia",
        created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
        updated_at: moment().format("YYYY-MM-DD HH:mm:ss"),
      };

      structClient.cpf_cnpj = this.oneClient ? this.oneClient.cpf_cnpj : null;
      this.saveClient(structClient);
      this.setCallTime("null");
      this.clearClient();
      this.clearAllClients();
      this.setChannel("");

      //LIMPANDO O CAMPO DE PRODUTO
      $(".select2-multi").val("-1").trigger("change");

      //Limpa o ponta de lanca
      await clientData.mutations.delDataTransduson();
    });

    connection.on(`QueueMemberPause-${user.getExtension()}`, (data) => {
      const queuename = data.Queue
      let find = this.userQueues.find(el => el.queue === queuename)
      const time = this.getTime();

      // Entrou em pausa
      if (data.Paused == 1) {
        this.setPauseTime(0);
        const dataPause = {
          pauseId: data.PausedReason,
          tempo: moment().format('YYYY-MM-DD HH:mm:ss'),
          queue: queuename,
          userId: parseInt(this.getId),
          preserveButton: this.userQueues.some(el => el.paused)
        };
        if (find) find.paused = true

        // this.sendPauseApi(dataPause);
        this.sendOperatorPauseApi(dataPause);
        this.selectPause(dataPause);

        // // Verificar se a pausa é "Campanha Preditiva" e se essa é a primeira fila pausada
        if (!this.userQueues.some(el => el.paused && el.queue !== queuename)) {
          if (dataPause.pauseId === 'Campanha Preditiva') {
            if (!this.getShowPreditivaCampaign) {
              this.setShowPreditivaCampaign();
            }

          }
          if (dataPause.pauseId === 'Campanha Cold Lead') {
            if (!this.getShowBillingCampaign) {
              this.setShowBillingCampaign();
            }
          }
          if (dataPause.pauseId === 'Campanha Esporádico') {
            if (!this.getShowImplantacaoCampaign) {
              this.setShowImplantacaoCampaign();
            }
          }
        }
      }

      // Saiu da pausa
      if (data.Paused == 0 && find.paused) {
        var x = {
          pauseId: data.PausedReason,
          tempo: moment().format('YYYY-MM-DD HH:mm:ss'),
          queue: queuename,
          userId: parseInt(this.getId),
        };

        // this.sendUnpause(x);
        this.sendOperatorUnpause(x);

        if (find) find.paused = false
      }

      if (!this.userQueues.some(el => el.paused) && this.getPauseTime !== 'null') {
        if (this.getShowPreditivaCampaign) {
          this.setShowPreditivaCampaign();
        }
        if (this.getShowBillingCampaign) {
          this.setShowBillingCampaign();
        }
        if (this.getShowImplantacaoCampaign) {
          this.setShowImplantacaoCampaign();
        }
        this.setPauseTime("null");
        this.comeBack(`${time}`);
      }
    });
  },
};
</script>

<style scoped>
.swal2-confirm[disabled] {
  cursor: not-allowed !important;
  /* Mostra o ícone de cursor de "não permitido" */
  opacity: 0.6;
  /* Faz o botão parecer desabilitado */
}

.num {
  width: 25px;
  height: 25px;
  text-align: center;
  text-combine-upright: all;
  left: 4em;
  border-radius: 50%;
  line-height: 25px;
  color: white;
  background-color: red;
  top: 5.5em;
  position: absolute;
}

.barra-lateral-esquerdo {
  background-color: #cccccc;
  width: 100%;
  max-width: 99px;
  text-align: center;
  border-right: solid 1px #1c869a;
  min-height: 100%;
  height: calc(100vh - 4.5em);
  overflow: auto;
}

::-webkit-scrollbar {
  width: 0.18rem;
}

::-webkit-scrollbar-track {
  background: #f38630;
}

::-webkit-scrollbar-thumb {
  background: #1c869a;
}

.figure-image {
  margin: 0px;
  display: block;
}

.figure-image div {
  margin: 0px;
  padding: 9px 0 9px 0;
}

.figure-image figcaption {
  color: white;
}

.backGroundOrangeRed {
  background-color: orangered;
}

.backGroundOrange {
  background-color: #fea33b;
}

.bg-adv {
  background: #1c869a;
}

.backgroundGreen {
  background: #27ae60;
}

.count-msg {
  padding: 0px;
  color: white;
  font-size: 1.5em;
}

strong .count-msg {
  font-size: 1.5em;
}

.remove-padding {
  padding: 0 !important;
}
</style>
